import { TYPES } from "./kyc.type";

const initState = {
  kycAll: null,
  kycOpenAdd: false,
  kycOpenEdit: false,
  kycSelected: null,
  kycSearch: "",
  //
  kycStep: 0,
  //contract
  kycOpenContract: false,
};

const kycReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_KYC_OPEN_CONTRACT:
      return {
        ...state,
        kycOpenContract: payload,
      };
    //
    case TYPES.SET_KYC_STEP:
      return {
        ...state,
        kycStep: payload,
      };
    //
    case TYPES.SET_KYC_ALL:
      return {
        ...state,
        kycAll: payload,
      };

    case TYPES.SET_KYC_OPEN_ADD:
      return {
        ...state,
        kycOpenAdd: payload,
      };

    case TYPES.SET_KYC_OPEN_EDIT:
      return {
        ...state,
        kycOpenEdit: payload,
      };

    case TYPES.SET_KYC_SELECTED:
      return {
        ...state,
        kycSelected: payload,
      };

    case TYPES.SET_KYC_SEARCH:
      return {
        ...state,
        kycSearch: payload,
      };

    default:
      return state;
  }
};

export default kycReducer;
